import React, { useState, useEffect, useContext } from "react";
import getStripe from '../../utils/getStripe'
import Button from "../../components/button/button";
import '../../css/paywall.css';
import { Tooltip } from 'react-tooltip';
import CreateAccountModal from "../signup/signup";
import LoginModal from "../login/login";
import SidebarContext from "../../contexts/MyContext";
import { usePremiumStatus } from "../../hooks/usePremiumStatus";
import SignUpHandler from "../../Apihander/signup/signupHandler";
import { useNavigate, useLocation } from "react-router-dom";
import FAQAccordion from "../../components/FAQAccordion/FAQAccordion";
import { useMakePayment } from "../../hooks/useMakePayment";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { firebaseApp, remoteConfig } from "../../config/firebaseConfig";
import { fetchAndActivate, getValue, activate } from "firebase/remote-config";
import paymentProcessingAnimation from '../../../src/animations/paymentProcessingAnimation'
import Lottie from "react-lottie";
import MobileDashboardHeader from "../../components/navbar/MobileDashboardHeader";






// keeps the "New" badge and info icon glued to the last word so they never wrap onto a line alone
const splitLastWord = (text = '') => {
  const words = text.trim().split(' ');
  const last = words.pop() || '';
  return { lead: words.join(' '), last };
};

const MobilePricing = () => {

  const navigate = useNavigate()
  const location = useLocation();

  const { startPolling } = usePremiumStatus();

  const { isPremium, setIsPremium, premiumLoading, setPremiumLoading, user, premiumStatusLoading, setPremiumStatusLoading, isPolling, setIsPolling, premiumStatus, setPremiumStatus, isAnnual, setIsAnnual, webPlanDetails } = useContext(SidebarContext)
  const { handleMakePaymentOfPremium } = useMakePayment();
  const [openIndex, setOpenIndex] = useState(new Set());
  const [collapsedIds, setCollapsedIds] = useState(new Set());
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false);
  const [isHovered, setIsHovered] = useState(false);



  const handleToggle = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnnual(prev => !prev);
      // Trigger fade in
      setTimeout(() => {
        setIsAnimating(false);
      }, 50);
    }, 250);
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: paymentProcessingAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  // const subscriptionData = {
  //   monthly: {
  //     price: webPlanDetails?.monthly_price,
  //     discountedPrice: null,  // No discount for annual
  //   },
  //   annual: {
  //     price: webPlanDetails?.monthly_price,
  //     discountedPrice: 8.99,
  //   },
  // };

  const subscriptionData = {
    monthly: {
      price: parseFloat(webPlanDetails?.monthly_price),
      discountedPrice: null,
    },
    annual: {
      price: webPlanDetails?.yearly_price,
      discountedPrice: parseFloat(webPlanDetails?.yearly_discounted_price),
    },
  };
  const activePlan = isAnnual ? subscriptionData?.annual : subscriptionData?.monthly;

  // Calculate Discount Percentage
  const calculateDiscountPercentage = (price, discountedPrice) => {
    if (!discountedPrice) return null;

    let discountAmnt = price - discountedPrice
    return Math.round((discountAmnt * 100) / price); // Round to nearest integer
  };

  const discountPercentage = calculateDiscountPercentage(activePlan?.price, activePlan?.discountedPrice);


  const contentArrayForFree = [
    {
      text: 'Record in high-quality audio.',
      tooltip: 'Capture crystal-clear audio recordings for a premium sound experience with every session.',
    },
    {
      text: 'Limit of 60 seconds per recording.',
      tooltip: 'Record up to one minute of audio, perfect for quick notes or reminders.',
    },
    {
      text: 'Unlimited standard-quality recordings.',
      tooltip: 'Enjoy endless recordings in standard audio quality, ideal for everyday use and simplicity.',
    },
    {
      text: 'Unlimited Recording Downloads.',
      tooltip: 'Save your recordings locally for easy access, sharing, or offline playback whenever needed.',
    },
    {
      text: 'Duplicate your recordings.',
      tooltip: 'Create duplicates of your recordings to keep backups or edit them for different purposes.',
    },
    {
      text: 'Edit recordings by trimming.',
      tooltip: 'Easily trim unwanted parts of your recordings, making them concise and focused.',
    },
    {
      text: 'Unlimited Sharing with Friends.',
      tooltip: 'Instantly share your audio recordings with friends via messaging or social media platforms.',
    },
  ];



  const contentArrayForPremium = [
    {
      name: 'Text to Speech',
      desc: 'Convert text into natural-sounding audio.',
      tooltip: 'Convert your text into natural-sounding speech with AI.',
      isNew: true,
    },
    {
      name: 'Audio Adjuster',
      desc: 'Reduce noise, boost volume, and adjust audio speed.',
      tooltip: 'Reduce background noise, boost volume, and adjust audio speed.',
      isNew: true,
    },
    {
      name: 'Extract Audio',
      desc: 'Extract audio from video files and save it to your recordings.',
      tooltip: 'Extract audio from video files and save it to your recordings.',
      isNew: true,
    },
    {
      name: 'Transcribe',
      desc: 'Convert your audio recordings into accurate text transcripts.',
      tooltip: 'Convert your audio recordings into accurate text transcripts.',
      isNew: true,
    },
    {
      name: 'Summary',
      desc: 'Get quick and concise summaries of your audio recordings.',
      tooltip: 'Get a quick AI-generated summary of your audio recording.',
      isNew: true,
    },
    {
      name: 'Translate',
      desc: 'Translate text into the language you choose.',
      tooltip: 'Translate text into the language you choose.',
      isNew: true,
    },
    {
      name: 'Unlimited access to premium AI tools',
    },
    {
      name: 'Unlimited high-quality recordings',
    },
    {
      name: 'Unlimited recording downloads',
    },
    {
      name: 'Trim and edit recordings',
    },
    {
      name: 'Add notes to recordings',
    },
    {
      name: 'Share recordings with friends',
    },
  ];

  const updateSubscriptionFlags = () => {
    navigate('/')
  }

  const handleItemClick = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const handleToggleCollapse = (id) => {
    setCollapsedIds((prevIds) => {
      const newSet = new Set(prevIds);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };


  const signUpOpenModal = () => {
    setSignUpModalOpen(true);
  };

  const signUpCloseModal = () => {
    setSignUpModalOpen(false);
    setIsPremium(false)
  };
  const signUpPremiumCloseModal = () => {
    setSignUpModalOpen(false);

  }

  const loginOpenModal = () => {
    setLoginModalOpen(true);
  };

  const loginCloseModal = () => {
    setLoginModalOpen(false);
    setIsPremium(false)

  };

  const loginPremiumCloseModal = () => {
    setLoginModalOpen(false);

  };

  const handleCancelPayment = async () => {
    try {
      setLoading(true)
      const data = await SignUpHandler.doCancelSubscription()
      if (data) {
        setLoading(false)
        setPremiumStatus(null)
        setIsPolling(false);

      }
    } catch (error) {
      console.error(error, 'error cancel subscription')
      setLoading(false)

    }
  }


  if (premiumStatusLoading) {
    return (
      <>
        <div className="premium_status">

          <div style={{ background: '#ffffff', padding: '100px 300px', borderRadius: '10px' }}>
            <div
              className="spinner-border spinner-login"
              role="status"
              style={{
                height: '2rem',
                width: '2rem',
              }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </>
    )
  }



  if (premiumStatus?.status === "SUCCESS") {
    return (
      <div className="premium_status d-flex justify-content-center align-items-center  p-3">
        <div className="bg-white rounded-3 p-4 p-sm-5 text-center w-100" style={{ maxWidth: '900px' }}>
          <img
            src="/img/success.png"
            alt="Success"
            className="mb-4"
            style={{ width: '87px', height: '122px', objectFit: 'contain' }}
          />
          <h1 className="text-success fw-bold fs-4">Payment Successful!</h1>
          <p className="text-secondary fw-medium fs-6 mt-3 mb-4">
            You have successfully purchased a monthly subscription for VoiceRecorder.
            Please click the Continue button below to proceed further.
          </p>
          <Button btnText="Continue" primary onClick={() => updateSubscriptionFlags()} />
        </div>
      </div>

    )
  } else if (premiumStatus?.status === 'FAILURE' || premiumStatus?.status === 'CANCEL' || premiumStatus?.response?.data?.status === 'CANCEL') {
    return (
      <div className="premium_status">
        <div style={{ padding: '100px 300px', background: '#ffffff', borderRadius: '10px' }}>
          <img src="/img/cancel.png" width="87px" height="122px" style={{ paddingBottom: '10px', objectFit: "contain" }} />
          <h1
            style={{
              fontFamily: 'Metropolis',
              fontWeight: '700',
              color: '#EF4444',
              fontSize: '24px'
            }}
          >
            Payment Failed!
          </h1>
          <p
            style={{
              fontFamily: 'Metropolis',
              fontSize: '14px',
              fontWeight: '500',
              color: '#334155',
              alignItems: 'center',
              width: '500px'
            }}
          >We're sorry, but your payment for monthly subscription was unsuccessful.
            Please check your payment details and try again.</p>
          <Button btnText={premiumLoading ? (

            <div
              className="spinner-border"
              role="status"
              style={{ width: "1.5rem", height: "1.5rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          ) :
            (
              <>
                Try Again
              </>
            )}
            primary
            onClick={() => handleMakePaymentOfPremium()}
          />
        </div>
      </div>
    )
  } else if (premiumStatus?.status === 'INTIATED_IN_PROGRESS' || premiumStatus?.response?.data?.status === 'INTIATED_IN_PROGRESS') {
    return (
      <>
        {
          user &&
          <MobileDashboardHeader
            showPricing={false}
            showDashboardNavigation={true}
          />
        }
      <div className="premium_status">
        <div style={{
          padding: '5%',
          background: '#ffffff',
          borderRadius: '10px',
          maxWidth: '100%',
          margin: '0 auto'
        }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Lottie options={defaultOptions} height={150} width={150} style={{ cursor: "default" }} />
          </div>
          <h1 style={{
            fontFamily: 'Metropolis',
            fontWeight: '700',
            color: '#F7CE46',
            fontSize: '24px',
            textAlign: 'center'
          }}>
            Processing Payment...
          </h1>
          <p
            style={{
              fontFamily: 'Metropolis',
              fontSize: '14px',
              fontWeight: '500',
              color: '#334155',
              maxWidth: '100%',
              textAlign: 'center',
              margin: '0 auto'
            }}
          >
            Your payment for Voice Recorder subscription is being processed. This may take a moment. Please wait, and avoid refreshing the page.
          </p>
          <p
            style={{
              fontFamily: 'Metropolis',
              fontSize: '14px',
              fontWeight: '500',
              color: '#334155',
              maxWidth: '100%',
              textAlign: 'center',
              margin: '15px auto 0'
            }}
          >
            After your successful payment, please come back on this screen and wait until we enable your subscription.
          </p>
          {/* Button code remains commented out as in original */}
        </div>
      </div>
      </>
    )
  } else if (premiumStatus === null || !premiumStatus || premiumStatus?.status === 'EXPIRE' || premiumStatus?.response?.data?.status === 'EXPIRE') {
    return (
      <>
      {
        user &&       
        <MobileDashboardHeader 
        showPricing={false}
        showDashboardNavigation={true}
        />
      }

        <div style={{ background: "#F8FAFC", paddingTop: "70px" }}>
          <div className=" container">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontFamily: 'Metropolis', fontSize: '48px', fontWeight: '700', lineHeight: '40px', letterSpacing: '-4%', color: '#000000', marginBottom: '40px' }}>
                Our Pricing
              </div>
              <div>
                <p style={{ fontFamily: 'Metropolis', fontSize: '1.1rem', fontWeight: '400', lineHeight: '24px', letterSpacing: '-4%', color: '#475569', marginBottom: '40px' }}>
                  Record, transcribe, merge, trim, and convert audio files effortlessly for meetings, notes, and music.
                </p>
              </div>
            </div>

            <div className="row p-2 price-card">
              <div className="col-sm-6 plan-free card-hover-effect" style={{ display: 'flex', alignItems: 'center', }}>
                <div className="card card-free " style={{ borderRadius: '16px', border: 'none', position: 'relative', overflow: 'hidden' }}>
                  <div className="card-header" style={{ textAlign: 'center', background: '#FFFFFF', }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Metropolis', fontSize: '1.1rem', fontWeight: '600', lineHeight: '40px', letterSpacing: '-4%', color: '#475569', marginBottom: '30px', gap: '0.5rem', marginTop: '15px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>

                      Standard
                    </div>
                    <div style={{ fontFamily: 'Metropolis', fontSize: '48px', fontWeight: '600', lineHeight: '18px', letterSpacing: '-4%', color: '#334155', textTransform: 'capitalize', marginBottom: '30px', }} >
                      <span>
                        free
                      </span>
                    </div>
                    <p style={{ color: '#94A3B8', textAlign: 'center', marginTop: '20px', marginBottom: '30px', fontSize: "0.9rem" }}>Perfect for getting started</p>

                  </div>
                  <div className="card-body" style={{ textAlign: 'center', boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08)', marginTop: '15px' }}>
                    <ul
                      className="free-plan-list" style={{

                        lineHeight: "2",
                        paddingLeft: "2px"

                      }}>

                      {contentArrayForFree.map((item, idx) => (
                        <li
                          key={idx}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            position: 'relative',
                          }}
                          // data-tooltip-id='icon-tooltip'
                          data-tooltip-id={`icon-tooltip-${idx}`}
                          data-tooltip-content={item.tooltip}
                        >
                          {/* <img src="./img/pricing/Check icon.png" height={20} width={20} /> */}
                          <svg className="check" width="20" height="20" viewBox="0 0 24 24" fill="none" color="#10B981" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12L10 17L19 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                          </svg>

                          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <span
                              key={idx}

                              // className="plan-free-text"
                              style={{
                                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                                fontWeight: '500',
                                // color: '#667085',
                                marginBottom: '0px',
                                marginLeft: '10px',
                                // fontSize: '0.95rem !important',
                                color: '#252A3A',
                                fontSize: '13px',
                                textAlign: 'left'
                              }}

                            >
                              {item.text}
                            </span>

                            <img
                              src="./img/pricing/UIicons.png"
                              height="24"
                              width="24"
                              alt="Icon"
                            />
                          </div>

                        </li>
                      ))}
                      {/* <Tooltip id='icon-tooltip'
                        place="bottom"
                        className="custom-tooltip" /> */}
                    </ul>

                    <button
                      onMouseEnter={() => setIsHovered(true)}
                      onMouseLeave={() => setIsHovered(false)}
                      style={{
                        // backgroundColor: !user ? "#FFFFFF" : "rgb(248, 250, 252)",
                        backgroundColor: !user
                          ? isHovered
                            ? "#E2E8F0"
                            : "#FFFFFF"
                          : "#E2E8F0",
                        padding: "12px 40px",
                        borderRadius: "8px",
                        fontSize: "16px",
                        fontWeight: "600",
                        fontFamily: "Metropolis",
                        color: !user ? "#334155" : "rgb(51, 65, 85)",
                        border: !user ? "1px solid #f3f4f6" : "none",
                        cursor: 'pointer',
                        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                        position: 'absolute',
                        bottom: '40px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '90%',
                        cursor: !user ? 'pointer' : 'not-allowed'

                      }}
                      className="signUp-for-free-btn"
                      // className={!user ? "signUp-for-free-btn" : ""}
                      onClick={() => {
                        if (!user) {
                          setSignUpModalOpen(true); setIsPremium(false)
                        }
                        // else {
                        //   const previousLocation = location.state?.from;

                        //   if (previousLocation) {
                        //     navigate(previousLocation);
                        //   } else {
                        //     navigate(-1);
                        //   }
                        // }
                      }}
                    >
                      {!user ? "Sign Up for Free" : "Your Current Plan"}

                    </button>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 card-hover-effect " style={{}}>
                <div className="card card-free" style={{ borderRadius: '16px', backgroundColor: '#ffffff', position: 'relative', border: '2px solid #FF7854 ', marginBottom:"20px" }}>
                  <div
                    className="recommended-tag"
                    style={{
                      position: 'absolute',
                      top: '-0px',
                      left: '81%',
                      transform: 'translateX(-50%)',
                      backgroundColor: '#FF7854',
                      color: '#ffffff',
                      fontWeight: '600',
                      padding: '4px 12px',
                      borderRadius: ' 0 0 0.5rem 0.5rem',
                      fontSize: '13px',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                      zIndex: '1',
                      // border: '2.5px solid #334155',
                      textTransform: 'uppercase',
                      letterSpacing: "0.5px"

                    }}>
                    RECOMMENDED
                  </div>
                  <div className="card-header" style={{ textAlign: 'center', marginTop: '15px', backgroundColor: '#ffffff' }}>

                    <div className="pricing-premium" style={{ display: 'flex', justifyContent: 'center', fontFamily: 'Metropolis', fontSize: '1.1rem', fontWeight: '600', color: '#475569', marginBottom: '15px', gap: '0.5rem', marginTop: '10px' }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#5468FF" stroke="#5468FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      Premium
                    </div>

                    {/* Toggle Switch */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'center',
                        // marginBottom: "20px"
                        margin: "1.5rem 0"
                      }}
                    >
                      <label
                        style={{
                          color: isAnnual ? '#475569' : '#475569',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        Pay for a Month
                      </label>

                      <label className="switch" style={{ margin: '0px' }}>
                        <input type="checkbox" checked={isAnnual} onChange={handleToggle} />
                        <span className="slider round"></span>
                      </label>

                      <label
                        style={{
                          color: isAnnual ? '#5468FF' : '#5468FF',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        Pay for a Year

                      </label>
                    </div>

                    <div className={`pricing-main pricing-container ${isAnimating ? 'fade-exit-active' : 'fade-enter-active'}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily: 'Metropolis',
                        fontSize: '48px',
                        fontWeight: '500',
                        color: '#334155',
                        marginTop: '20px'
                      }}
                    >
                      {/* Original Price */}
                      <div className="pricing-container" style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          className="pricing-container-span"
                          style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            color: '#94A3B8',
                            marginRight: '10px',
                            marginTop: '17px',
                            textDecoration: 'line-through',
                            minWidth: '55px',
                            textAlign: 'right',
                            visibility: isAnnual && activePlan?.discountedPrice ? 'visible' : 'hidden',
                          }}
                        >
                          ${activePlan?.price}
                        </span>

                        {/* Discounted or Regular Price */}
                        <p className="main-price-container" style={{ marginBottom: '0px', textAlign: 'center', fontWeight: '600', }}>
                          ${activePlan?.discountedPrice ? activePlan?.discountedPrice : activePlan?.price}
                          <span style={{ fontSize: '1.1rem', fontWeight: '600', marginRight: '10px', marginLeft: '4px' }}>{isAnnual ? "for 1 Year" : "for 1 month"}</span>
                        </p>
                      </div>

                      {/* Discount Tag */}
                      <span
                        style={{
                          fontSize: '15px',
                          fontWeight: '500',
                          color: '#ffffff',
                          background: '#5468FF',
                          borderRadius: '6px',
                          padding: '3px 6px',
                          marginTop: '10px',
                          minWidth: '81px',
                          textAlign: 'center',
                          visibility: isAnnual && discountPercentage ? 'visible' : 'hidden',
                        }}
                      >
                        Save {discountPercentage}%
                      </span>
                    </div>




                    {/* <p
                      className={`pricing-container ${isAnimating ? 'fade-exit-active' : 'fade-enter-active'}`}
                      style={{ color: '#64748B', marginTop: '7px', textAlign: 'center', fontFamily: 'Metropolis', height: '20px', fontSize: '16px', fontWeight: '600' }}>{isAnnual ?
                        // "Billed Annually"
                        "" : ''}</p> */}

                    <p style={{ color: '#94A3B8', textAlign: 'center', marginBottom: '30px', fontSize: "0.9rem" }}>Unlock powerful AI audio tools</p>

                    {/* <div style={{ position: 'relative', textAlign: 'center', marginBottom: '20px', }}>
                      <button
                          style={{
                            backgroundColor: "#ffffff",
                            padding: "12px 40px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "600",
                            fontFamily: "Metropolis",
                            color: "#334155",
                            border: "none",
                            cursor: 'pointer',
                            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                            width: '100%',
                          }}
                          onClick={() => {
                            if (!user) {
                              setSignUpModalOpen(true);
                              setIsPremium(true);
                            } else {
                              handleMakePaymentOfPremium();
                            }
                          }}
                        >
                          {premiumLoading ? (
                            <div
                              className="spinner-border"
                              role="status"
                              style={{ width: "1.5rem", height: "1.5rem" }}
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          ) : (
                            "Get Premium"
                          )}
                        </button>

                    </div> */}
                  </div>
                  <div className="card-body" style={{ position: 'relative', textAlign: 'start', boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
                    borderBottomLeftRadius: "16px",
                    borderBottomRightRadius: "16px"
                   }}>

                    {/* <div style={{ padding: '20px 32px' }}> */}
                    <div style={{ padding: '20px 2px' }}>

                      <ul style={{ marginBottom: '70px', paddingLeft: '0px', transition: 'opacity 0.3s ease-in-out', opacity: 1, lineHeight: "2" }}>
                        {contentArrayForPremium.map((item, idx) => {
                          const { lead, last } = splitLastWord(item.desc);

                          return (
                            <li className="premium-plan-item" key={idx}>
                              <svg className="check" width="20" height="20" viewBox="0 0 24 24" fill="none" color="#10B981" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 12L10 17L19 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>

                              <p className="plan-free-text premium-plan-text">
                                <span className="premium-plan-name">{item.name}</span>
                                {item.desc ? ` – ${lead} ` : ' '}

                                <span className="premium-plan-tail">
                                  {last}
                                  {item.isNew && <span className="new-badge">New</span>}
                                  {item.tooltip && (
                                    <>
                                      <img
                                        className="feature-info-icon"
                                        src="./img/pricing/UIicons.png"
                                        height="24"
                                        width="24"
                                        alt="More info"
                                        data-tooltip-id={`icon-tooltip-${idx}`}
                                        data-tooltip-content={item.tooltip}
                                      />
                                      <Tooltip
                                        id={`icon-tooltip-${idx}`}
                                        place="bottom"
                                        className="custom-tooltip"
                                      />
                                    </>
                                  )}
                                </span>
                              </p>
                            </li>
                          );
                        })}

                      </ul>

                      <button
                        className="hover-btn"

                        style={{ padding: "12px 40px", borderRadius: "8px", fontSize: "16px", fontWeight: "600", fontFamily: "Metropolis", color: "#FFFFFF", border: "none", cursor: 'pointer', boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)", position: 'absolute', bottom: '40px', left: '50%', transform: 'translateX(-50%)', width: '90%' }} onClick={() => {
                          if (!user) {
                            setSignUpModalOpen(true); setIsPremium(true);
                          } else {
                            handleMakePaymentOfPremium()
                          }
                        }}>
                        {premiumLoading ? (
                          <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem", }}>
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : "Get Premium"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div >
        <div className="container-fluid" style={{ background: "#F8FAFC", }}>

          <div style={{ padding: "60px 0" }}>
            <h3 className="text-center" style={{ marginBottom: "40px" }}>
              Frequently Asked Questions
            </h3>
            <div
              style={{ maxWidth: "900px", margin: "0 auto" }}
            >
              <FAQAccordion />
            </div>
          </div>
        </div>

        {
          signUpModalOpen && (
            <CreateAccountModal
              closeModal={signUpCloseModal}
              openModal={loginOpenModal}
              closePremiumModal={signUpPremiumCloseModal}
            />
          )
        }
        {
          loginModalOpen && (
            <LoginModal closeModal={loginCloseModal} openModal={signUpOpenModal} closePremiumModal={loginPremiumCloseModal} />
          )
        }
      </>
    )
  }



}

export default MobilePricing
